import {useTranslations} from "next-intl";
import {Text} from "@chakra-ui/react";
import moment from "moment";

export function LastUpdated({updatedAt}: {updatedAt: number|undefined}) {
    const t = useTranslations("Home")
    return (
        <Text data-nosnippet mb={0} fontSize="10pt" textAlign="end" color="gray">{t("updated_last")} {moment(updatedAt).fromNow()}</Text>
    )
}